import { render, staticRenderFns } from "./Alumni.vue?vue&type=template&id=28602006"
import script from "./Alumni.vue?vue&type=script&lang=js"
export * from "./Alumni.vue?vue&type=script&lang=js"
import style0 from "./Alumni.vue?vue&type=style&index=0&id=28602006&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports